import oidc from "oidc-client";
import { getQueryStringValue } from "../../framework/core/core";
import "../core";
import * as core from "../core/core";
import { getBrandName } from "../core/getBrandName";
import * as page from "../core/page";
import React, { useContext } from "react";
import ReactDOM from "react-dom";
import {
    DynamicSSO,
    decodeTokenPayload,
    useAlerts,
    ZLogin
} from "@msidata/zeact";
import { ThemeContext } from "styled-components";
import { getAuth0Config, usingAuth0 } from "../core/util/util";
import styled from "styled-components";
import { ZeactWrapper } from "../../framework/components/zeactWrapper";

const FixStyles = styled.div`
    all: initial;
    font-family: "Segoe UI", "Trebuchet MS", Tahoma, Verdana, Arial, sans-serif;
    -webkit-font-smoothing: "antialiased";
    & button {
        padding: unset;
        font-size: 11px;
    }
    & div {
        text-align: center;
    }
    & input {
        height: 40px;
        background-color: white;
    }
    & .z-alert {
        & .alert {
            &:before {
                content: unset;
            }
            font-family: "Segoe UI", "Trebuchet MS", Tahoma, Verdana, Arial,
                sans-serif;
            font-size: 14px;
            box-shadow: unset;
            & button {
                font-size: 14px;
            }
        }
        & .alert.header {
            padding: 0;
            margin: 0px 10px 0px 0px;
        }
        & .alert.message {
            padding: 0;
            margin: 0;
        }
    }
`;



const Login = (props: { theme: any }) => {
    const authConfig = getAuth0Config();
    const disableSSORegex = new RegExp(authConfig.disableSSORegex);
    const nonSSOConnections = authConfig.nonSSOConnections;
    const { theme } = props;
    const { issueAlert } = useAlerts();
    const loginError = localStorage.getItem("loginError");
    if (loginError) {
        const parsed = JSON.parse(loginError);
        const { correlationId } = parsed;
        console.error("An error occurred while logging in", parsed);
        issueAlert({
            type: "error",
            header: "LoginErrorHeader",
            message: "LoginErrorMessage",
            variables: [correlationId],
            autoHideDuration: undefined,
            persist: true
        });
        localStorage.removeItem("loginError");
    }

    return (
        <DynamicSSO
            disableSSORegex={disableSSORegex}
            nonSSOConnections={nonSSOConnections}
            authConfig={authConfig}
            theme={theme}
        >
            <ZLogin theme={theme} />
        </DynamicSSO>
    );
};

const LoginWrapper = () => {
    const theme = useContext(ThemeContext);

    return (
        <FixStyles>
            <ZeactWrapper>
                <Login theme={theme} />
            </ZeactWrapper>
        </FixStyles>
    );
};

const renderLogin = () => {
    const divId = "AuthLoginContainer";
    const auth0Div = document.getElementById(divId);
    let div: HTMLElement;
    if (auth0Div) {
        auth0Div.innerHTML = "";
        div = auth0Div;
    } else {
        const newDiv = document.createElement("div");
        newDiv.id = divId;
        div = newDiv;
    }

    ReactDOM.render(<LoginWrapper />, document.body.appendChild(div));
};

getBrandName();
core.loadIdentityServerSettings();

if (usingAuth0()) {
    const authResult = localStorage.getItem("authResult") || null;
    if (authResult === null) {
        renderLogin();
    } else {
        const parsed = JSON.parse(authResult) || null;
        const accessToken = parsed.accessToken || null;
        if (accessToken === null) {
            localStorage.clear();
            renderLogin();
        } else {
            const { exp } = decodeTokenPayload(accessToken);
            const lsCompanyId = localStorage.getItem("Company-Id");
            const companyId = parseInt(lsCompanyId, 10);
            if (exp - Date.now() >= 0 || !(lsCompanyId && companyId > 0)) {
                localStorage.clear();
                renderLogin();
            } else {
                window.location.href = "/Home";
            }
        }
    }
} else {
    page.append(page.loginLayout);

    if (localStorage.getItem("IDSIDToken")) {
        window.location.href = "/Home";
    } else {
        const loginError = localStorage.getItem("loginError");
        if (loginError) {
            const parsed = JSON.parse(loginError);
            console.error("An error occurred while logging in", parsed);
            localStorage.removeItem("loginError");
        }
        var prompt = window.location.search.indexOf("prompt=login") > -1;
        var manager = new oidc.UserManager(core.identityServerSettings);
        var redirectParameters: any = {
            login_hint: getQueryStringValue("email")
        };

        if (prompt || localStorage.getItem("promptLogin")) {
            redirectParameters.prompt = "login";
            redirectParameters.acr_values = "prompt:login";
        }

        manager.signinRedirect(redirectParameters);
    }
}
